import * as React from 'react';
import { MePage } from './model';
import { MePageView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';
import { IRoute } from 'lib/componentRouter';

export const MePageRoute = (mepage : MePage, appWrapper : AppWrapper) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper} navbarTab={NavbarTab.Me}>
            <MePageView model={mepage} />
        </AppWrapperView>
});


// WEBPACK FOOTER //
// ./apps/portcall/mepage/route.tsx